module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "features-internal"
  }, [_c('a', {
    staticClass: "features-internal-anchor",
    attrs: {
      "href": _vm.feature.link
    }
  }, [_c('div', [_c('img', {
    staticClass: "swiper-lazy",
    attrs: {
      "data-src": _vm.feature.thumbnail.url,
      "width": "550px",
      "height": "550px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "features-internal-info"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.feature.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "features-internal-date"
  }, [_vm._v(_vm._s(_vm.feature.date) + " "), _c('tags', {
    attrs: {
      "categories": _vm.feature.categories || [],
      "size": "small"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b17b09f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/features/features-slide-element.vue
// module id = 168
// module chunks = 5